import React from "react";
import { BrowserRouter, Routes, Route, useNavigate, Navigate } from "react-router-dom";
import MainPage from "./page1";
import SlotMachinePage from "./page2"; // enthält Seite2 & Seite3
import Login from "./login";
import Dashboard from "./dashboard";
import Payment from "./payment";
import Analyze from "./analyze";
import LogoPage from "./logo-page";
import Interact from "./cms-interact/Interact";


// Wrapper für Navigation
const SlotMachinePageWithNavigation = () => {
  const navigate = useNavigate();
  return <SlotMachinePage goToMainPage={() => navigate("/")} />;
};

const App3 = () => {
  return (
    <BrowserRouter>
      <Routes>
        {
        <Route path="/logo" element={<LogoPage />} />}
        <Route path="/" element={<Navigate to="/Interact/main-page" replace />} />
        <Route path="/main" element={<MainPage />} />
        <Route path="/spiel" element={<SlotMachinePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/analyze" element={<Analyze />} />
        <Route path="/Interact/:slug" element={<Interact />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App3;
